import React from "react";
import { OrderOfPlayProps } from "./types";
import { useLazyLoad } from "../../../helpers/hooks";
const Comp = React.lazy(() => import("./OrderOfPlay"));

export default (props: OrderOfPlayProps) => useLazyLoad(<Comp {...props} />);
